import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { ActionButtonV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Giấy báo nợ';
    case 'history':
      return 'Lịch sử';
    default:
      return 'Giấy báo nợ';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
  }
) => {
  const { onAdd, onEdit, onDelete, onCopy, handleClose } = handlers;

  if (formMode !== 'view') {
    return null;
  }

  switch (activeTab) {
    case 'info':
      return (
        <>
          <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} />
          <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} />
          <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} />
          <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} />
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={handleClose} />
        </>
      );
    case 'history':
      return (
        <>
          <ActionButtonV2
            icon={RefreshCircle1ClockwiseStroke}
            title='Refresh'
            variant='secondary'
            onClick={() => console.log('refresh')}
          />
          <ActionButtonV2
            icon={SignPostLeftStroke}
            title='Cố định cột'
            variant='secondary'
            onClick={() => console.log('pin')}
          />
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' variant='secondary' onClick={handleClose} />
        </>
      );
    default:
      return (
        <>
          <ActionButtonV2 icon={FloppyDisk1Stroke} title='Lưu' type='submit' />
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={handleClose} />
        </>
      );
  }
};
